import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CREATE_COMPETITION_DRAFT } from '../../api/config';

function CreateCompetitionModal(props) {
  const [draftName, setDraftName] = useState('');
  const [validated, setValidated] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity()) {
      const data = {
        competitionName: draftName,
      };

      let navigateUrl = '/organizer/competitions/{id}/details';
      const token = localStorage.getItem('token');

      fetch(CREATE_COMPETITION_DRAFT, {
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          if (data.statusCode === 201) {
            navigateUrl = navigateUrl.replace('{id}', data.id);
            navigate(navigateUrl);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
    setValidated(true);
  };

  return (
    <Modal
      {...props}
      centered
      aria-labelledby='contained-modal-title-vcenter'
      className='p-3'
    >
      <Modal.Header closeButton>
        <Modal.Title>Ny tävling</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Ange namn för tävlingen. Övriga uppgifter fyller du i senare. Du
          väljer senare när du vill publicera den.
        </p>
        <Form
          id='form-create-draft'
          onSubmit={handleSubmit}
          noValidate
          validated={validated}
        >
          <Form.Group controlId='formName'>
            <Form.Label>Namn</Form.Label>
            <Form.Control
              required
              onChange={(e) => setDraftName(e.target.value)}
              type='text'
              placeholder='Ange namn'
            ></Form.Control>
            <Form.Control.Feedback type='invalid'>
              Ange ett namn för tävlingen
            </Form.Control.Feedback>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className='d-flex justify-content-between'>
        <Button onClick={() => props.onHide()} variant='outline-secondary'>
          Avbryt
        </Button>
        <Button type='submit' form='form-create-draft'>
          Skapa utkast
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CreateCompetitionModal;
